import React from 'react';

import {OETarget} from '../../../react-oe/oe-target';
import OEIconCodes from '../../../lib/oe-icon-codes';
import OEProtoCapBar from '../oe-proto-cap-bar';
import {OEOrthoTargetType, OEOrthoTargets, OEOrthoFeatureAccess, OEOrthoStartSelectionData} from './oe-ortho-model';

export default class OEOrthoCapBar extends React.PureComponent {

    constructor(props) {
        super(props);

        this.targetTypeMap = {
            [OEOrthoTargetType.head]:      {icon: OEIconCodes.ortho.headTarget, titleId: 'target_menu_head'},
            [OEOrthoTargetType.anatomy]:   {icon: OEIconCodes.ortho.anatomyTarget, titleId: 'target_menu_anatomy'},
            [OETarget.effigosExplorerHelp]: {target: OETarget.effigosExplorerHelp, icon: OEIconCodes.help, noTargetTypeBarEntry: true, titleId: 'target_menu_effigosExplorerHelp'}
        };
    }

    render()    {
        let targetTypes = [OEOrthoTargetType.anatomy, OEOrthoTargetType.head, OETarget.effigosExplorerHelp];

        return (
            <OEProtoCapBar
                {...this.props}
                targetTypes={targetTypes}
                targetTypeMap={this.targetTypeMap}
                versionTargets={OEOrthoTargets}
                featureAccess={OEOrthoFeatureAccess}
                startSelectionData={OEOrthoStartSelectionData}
            />
        );
    }
}